import { defineCopy } from "@tami/core/intl";

import { PROPOSALS_SCRIPT_COPY_EN_US } from "./en-us/proposals-script.copy";
import { PROPOSALS_SCRIPT_COPY_ES_ES } from "./es-es/proposals-script.copy";

export const PROPOSALS_SCRIPT_COPY_PT_BR = {
  propIntro: {
    narrative:
      "Do lado da Collab, precificar não é uma publi: é um orçamento com vários creators dentro.",
  },
  propToolbar: {
    narrative:
      "Suas propostas ficam salvas e reutilizáveis — a próxima marca começa da anterior, não do zero.",
    callout:
      "Busque, duplique e monte a proposta seguinte em minutos.",
  },
  propOverview: {
    narrative:
      "Uma proposta por marca, com o pacote inteiro do quadro.",
  },
  propCards: {
    narrative:
      "Cada card mostra o que a marca paga, quanto fica de comissão e quem do quadro entra no pacote.",
    callout:
      "As fotos no rodapé são os creators da proposta — três e o resto vira +N.",
  },
  propConverted: {
    narrative:
      "Fechou? A proposta vira campanha com os creators e entregáveis já preenchidos.",
    callout:
      "A convertida fica marcada — você não refaz o que já virou campanha.",
  },
} as const;

export const PROPOSALS_SCRIPT_COPY = defineCopy(PROPOSALS_SCRIPT_COPY_PT_BR, {
  "en-US": PROPOSALS_SCRIPT_COPY_EN_US,
  "es-ES": PROPOSALS_SCRIPT_COPY_ES_ES,
});
